// @ts-nocheck
/* eslint-disable */
"use client";

import {
  BlockStyleProps,
  BlocksProps,
} from "@/lib/wordpress/_types/blocksStyle";
import { Column, Row } from "politicamente-informados-ds";

import { CSSProperties } from "react";
import cn from "classnames";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";

/**
 * TODO:
 * Alterei o tipo de blocks por esta interface. Em alguns cenários eu não sabia o que vinha nos objectos portanto
 * marquei como <Record<string, unknown>> ou <Record<string, unknown>>[] ou <Record<string, string[quando sabia que chegava uma string]>> ln.55 eg.
 */
export type IBlockColumns = {
  attrs: {
    anchor?: string;
    align?: string;
    fluid?: boolean;
    backgroundColor?: string;
    textColor?: string;
    verticalAlignment?: string;
    isStackedOnMobile?: boolean;
    mobileSpaced?: boolean;
    className?: string;
    style?: BlockStyleProps | CSSProperties | undefined;
  };
  innerBlocks: BlocksProps[];
};

export default function BlockColumns({ attrs, innerBlocks }: IBlockColumns) {
  const {
    anchor,
    align,
    fluid,
    backgroundColor,
    textColor,
    verticalAlignment,
    isStackedOnMobile,
    mobileSpaced,
    className,
    style,
  } = attrs || {};

  const rowStyle = getBlockStyles({
    textColor,
    backgroundColor,
    style,
  });

  return (
    <>
      {!!innerBlocks?.length && (
        <Row
          // id={anchor || undefined}
          className={className?.replace(
            "is-style-rounded",
            "radius-md shadow-sm"
          )}
          align={
            verticalAlignment === "bottom" ? "flex-end" : verticalAlignment
          }
          fluid={fluid}
          mobileSpace={mobileSpaced}
          style={rowStyle as CSSProperties}
        >
          {!!innerBlocks?.length &&
            innerBlocks?.map(
              (column: Record<string, unknown>, index: number) => {
                const attrs = column?.attrs as Record<string, unknown>;
                const size = Math.round(
                  parseFloat(attrs?.width as string) * 0.12
                );
                const columnStyle = getBlockStyles({
                  textColor: attrs?.textColor as string,
                  backgroundColor: attrs?.backgroundColor as string,
                  style: attrs?.style as Record<string, unknown>,
                });

                let alignClass = "";
                if (attrs?.textAlignMobile && attrs?.textAlign) {
                  alignClass = `text-${attrs?.textAlignMobile} text-md-${attrs?.textAlign}`;
                } else {
                  if (attrs?.textAlign) alignClass = `text-${attrs?.textAlign}`;
                  if (attrs?.textAlignMobile)
                    alignClass = `text-${attrs?.textAlignMobile} text-md-start`;
                }

                return (
                  <Column
                    key={`column-${index}`}
                    xs={!isStackedOnMobile ? size : 12}
                    lg={size}
                    align={
                      attrs?.verticalAlignment === "bottom"
                        ? "flex-end"
                        : attrs?.verticalAlignment
                    }
                    mobileOrder={attrs?.mobileOrder && attrs?.mobileOrder}
                    className={cn(alignClass, attrs?.className as string)}
                    style={columnStyle as CSSProperties}
                  >
                    {!!(column?.innerBlocks as Record<string, unknown>[])
                      ?.length &&
                      (column?.innerBlocks as Record<string, unknown>[])?.map(
                        (block: object, index: number) => {
                          return displayBlock(block as BlocksProps, index);
                        }
                      )}
                  </Column>
                );
              }
            )}
        </Row>
      )}
    </>
  );
}
